<template>
  <portlet
    :icon="'fad fa-mobile'"
    :title="name"
    :actionsBlock="true"
  >
    <template slot="portletBody">
      <div class="category-container row" style="margin-bottom: 1.5rem" v-if="Can(rights.DOCUMENT_VIEW)">
        <div class="col-10">
            <section-menu 
                :menu="menu" 
                :entry="menuEntry"
                @entryClick="menuClick($event)"
                >
            </section-menu>
        </div>
        <div class="col-2">
            <div class="float-right" style="margin-right: 0rem">
                <input type="file" ref="file" style="display: none" v-on:change="(e) => setFile(e)"/>
                <button class="btn btn-primary" @click="$refs.file.click()"><img src="../../assets/icons/upload-logs.png" height="20px"/> Upload Document</button>
            </div>
        </div>
      </div>
      <hr/>
      <div class="category-container row">
        <div class="col-10">
            <div class="row">
                <div :class="getCategoryClass(forCategory)" v-for="(forCategory, key) in categories" v-bind:key="key" @click="categoryClick(forCategory)">
                    {{ forCategory.name }}
                </div>
            </div>
        </div>
        <div class="col-2">
            <div class="row justify-content-end">
                <div :class="getYearClass(forYear) + ' float-right'" v-for="forYear, key in years" v-bind:key="key" @click="yearClick(forYear)">
                    {{ forYear }}
                </div>
            </div>
        </div>
      </div>
      
      <div class="documents-container row">
        <div  class="col-xs-1 col-lg-3 col-xl-2" v-for="document in documentsOfYearAndCategory()" v-bind:key="document.id">
            <document :document="document"/>
        </div>
      </div>
      <upload-document
        v-if="true"
        :value="upload"
        :name="'upload-modal'"
        :category="category"
        :flexworker="name"
        :categories="categories"
        :organizations="organizations"
        :file="file"
        :flexworkers="flexworkers"
        @saveChanges="uploadFile($event)"
      >
      </upload-document>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import Vue from 'vue';
  import store from '../../store.js';
  import document from '../../components/documents/document.vue';
  import { Can } from '../../../permission/ability.js';
  import uploadDocument from '../../components/documents/uploadDocument.vue'
  import sectionMenu from '../../components/documents/sectionMenu.vue'
  import { RIGHTS } from '../roles/rights';

  export default {
  components: { document, uploadDocument, sectionMenu },
    mixins: [dataTables, swalModals],
    data() {
      return {
        id: '',
        rights: {},
        name: '',
        isAdmin: false,
        documents: [],
        categories: [],
        years: [],
        year: null,
        category: null,
        user: null,
        nextPageToken: null,
        customFilters: [],
        modalId: null,
        upload: {name: '', rights: []},
        organizations: [],
        employment: null,
        file: null,
        menuEntry: {id:2, name: 'Documents'},
        menu: [{name: 'Leave', id: 1, right: RIGHTS.LEAVEREQUESTS_VIEW}, {name: 'Documents', id: 2, right: RIGHTS.DOCUMENT_VIEW}, {name: 'Archived chats', id: 3, right: RIGHTS.CHAT_VIEW}],
        flexworkers: []
      };
    },
  async   created() {
      this.rights = RIGHTS;
      this.$store.commit('setLoading',true)
      this.id = parseInt(this.$route.params.employment)
      this.category = parseInt(this.$route.params.category)
      this.name = this.$route.params.name
      await  this.fetchData();
      this.$store.commit('setLoading',false)
      this.isAdmin = this.$store.state.users.me.admin;

      if(this.employment === null || this.employment.id !== this.id) {
        let employment = this.getEmployment
        if(employment.id === undefined || employment.id !== this.id) {
            store.dispatch('employments/get', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, employment_id: this.id}).then((res) => {
                if (res.status === 200) {
                    this.employment = res.data.data
                }
            }).catch((err) => {
                console.log(err)
                alert('Unexpected error downloading employments')
            });

        }
      }
    },
    methods: {
      Can,
      async  fetchData() {
        this.$store.commit('setLoading',true)
        store.dispatch('organizations/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            this.organizations = res.data.data
          }
        }).catch((err) => {
            console.log(err)
            alert('Unexpected error downloading organizations')
        });

        store.dispatch('flexworkers/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            this.flexworkers = res.data.data;
          }
        }).catch((err) => {

        });

        await store.dispatch('documents/getCategories', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            this.categories = res.data.data;
            this.nextPageToken = res.nextToken;
          }
        }).catch((err) => {
            console.log(err)
            alert('Unexpected error downloading document categories')
        });

        await store.dispatch('documents/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, employment_id: this.id}).then((res) => {
          if (res.status === 200) {
            let documents = res.data.data
            let employmentDocs = []
            let years = []

            // let's count documents per employment
            let documentLine = []
            documents.map((document, key) => {
                // Index by employment id
                let year = moment(document.created_at, "YYYY-MM-DD").year()
                
                if(!years.includes(year)) {
                    years.push(year)
                }
            })
            
            years.sort()
            this.years = years
            this.year = this.years[0]

            // Prepare the data to be sent to the view
            employmentDocs.map((document, key) => {
                for (const [documentCategory, key2] of Object.entries(document['category'])) {
                    documentLine.push({...document, amount: key2, category: documentCategory})
                }
            })

            this.documents = documents;
            this.nextPageToken = res.nextToken;
          }
        }).catch((err) => {

        });

          this.$store.commit('setLoading',false)
      },
      setFile(e) {
        if(e.target.files && e.target.files.length > 0) {
            this.file = e.target.files[0]
        } else {
            this.file = null
        }
        
      },
      menuClick(event) {
        this.menuEntry = event
        switch(event.id) {
            case -1:
                this.$router.push('/hours')
            break;
            case 1:
                this.$router.push('/leave-requests/' + this.id + '/' + this.name)
            break;
            case 2:
                this.$router.push('/documents/' + this.id + '/1/' + this.name)
            break;
            case 3:
                this.$router.push('/archived-chats/' + this.id + '/' + this.name)
            break;
        }
      },
      uploadFile(event) {
        console.log(event)
        store.dispatch('documents/createDocument', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, file: this.file, documentCategoryId: event.category, employmentId: this.id}).then((res) => {
            
            if (res.status === 201) {
                this.$swal({
                    title: "Success!",
                    html: 'The document has been published correctly',
                    type: "info",
                    confirmButtonText: 'Oké',
                    reverseButtons: true,
                }).then(() => {
                    this.fetchData()
                })
            }
        }).catch((err) => {
            console.log(err)
            alert('Unexpected error uploading the document')
        });
      },
      getYear(document) {
        return moment(document.created_at, 'YYYY-MM-DD').year()
      },
      yearClick(year) {
        this.year = year
      },
      getYearClass(year) {
        return year === this.year ? 'year-widget active' : 'year-widget'
      },
      categoryClick(category) {
        this.category = category.id
      },
      getCategoryClass(category) {
        return category.id === this.category ? 'sub-category-widget active' : 'sub-category-widget'
      },
      getCategory(document) {
        return document.category.id
      },
      documentsOfYearAndCategory() {
        // Filter documents of the current year and category
        let t = this.documents.filter((doc, key) => {
            if(this.year === this.getYear(doc) && this.category === this.getCategory(doc) && doc.file !== null) {
                return doc;
            }
        })
        return t
      }
    },
    computed: {
      ...mapGetters('roles', ['getRoles']),
      ...mapGetters('employments', [
          'getEmployment'
        ]),
    },
    watch: {
        file(newV, oldV) {
            if(newV !== null) {
                console.log(newV)
                $('.modal').modal('show') ;
            }
        }
    }
  };
</script>
